import React, { useEffect, useState, useGlobal } from "reactn";
import PropTypes from "prop-types";
import DeliveryStatusLabel from "../../deliveryStatusLabel/DeliveryStatusLabel";
import { DeliveryItemsGridStyled, DeliveryItemsGridWrapperStyled, DeliveryItemsGridHeadersStyled, DeliveryItemsLinkStyled, DeliveryItemsColStyled } from "./DeliveryItemsGrid.styled";
import NoItemsCTA from "../NoItemsMessage/NoItemsCTA";

const DeliveryItemsGrid = ({ data, noItemsMsg, role, id, ariaLabelledby, activeTab }) => {
    const [itemsToShow, setItemsToShow] = useState(0);
    const [isBusiness, setIsBusiness] = useGlobal("isBusiness");

    useEffect(() => {
        setItemsToShow(data.length > 3 ? 3 : data.length);
    }, [data]);

    // Capitalise the first letter of each word supplied
    const capitaliseFirstLetters = str => {
        if (!str) return "";
        if (!str.trim()) return "";
        const updatedStr = str
            .trim()
            .toLowerCase()
            .split(" ");

        for (let i = 0, x = updatedStr.length; i < x; i += 1) {
            if (updatedStr[i][0]) {
                updatedStr[i] = updatedStr[i][0].toUpperCase() + updatedStr[i].substr(1);
            }
        }

        return updatedStr.join(" ");
    };

    const formatTrackingNumber = string => {
        return string.length === 13 ? `${string.substr(0, 2)} ${string.substr(2, 3)} ${string.substr(5, 3)} ${string.substr(8, 3)} ${string.substr(11, 3)}` : string;
    };

    const getDeliveryItemTitle = item => {
        return formatTrackingNumber(item.trackingNumber);
    };

	const showDeliveryDetails = (e) => {
		// return if a key is pressed that isn't enter or space 
		if (typeof e.keyCode !== "undefined" && e.keyCode !== 13 && e.keyCode !== 32) {
			return;
		}

		window.location.href = `${window.location.origin}/myAccount/My-deliveries`;
	};

    return (
        <DeliveryItemsGridStyled role={role} id={id} aria-labelledby={ariaLabelledby}>
            {data && data.length > 0 ? (
                <DeliveryItemsGridWrapperStyled>
                    <DeliveryItemsGridHeadersStyled>
                        <div>Status</div>
                        <div>{activeTab === "receiving" ? 'From' : 'To'}</div>
                        <div>Tracking number</div>
                    </DeliveryItemsGridHeadersStyled>
                    {data.slice(0, itemsToShow).map(obj => {
                        return (
                            <DeliveryItemsLinkStyled
                                key={obj.trackingNumber}
                                role="link"
                                onClick={showDeliveryDetails}
                                onKeyDown={showDeliveryDetails}
                                tabindex="0"
                                isBusiness={isBusiness}
                            >
                                <DeliveryItemsColStyled>
                                    <div className="mobileHeading">Status</div>
                                    <DeliveryStatusLabel status={obj.lastTrackingEventCategoryId}></DeliveryStatusLabel>
                                </DeliveryItemsColStyled>
                                <DeliveryItemsColStyled className="subTitle">
                                    <div className="mobileHeading">{activeTab === "receiving" ? 'From' : 'To'}</div>
                                    {obj.returnType === "RECEIVER" ? (
                                        <div>{obj.retailerName !== "" ? <>{obj.retailerName}</> : <>Sender Uknown</>}</div>
                                    ) : (
                                        <div>
                                            {capitaliseFirstLetters(obj.recipientName)}
                                        </div>
                                    )}
                                </DeliveryItemsColStyled>
                                <DeliveryItemsColStyled className="orderNumber">
                                    {obj.trackingNumber ? (
                                        <>
                                            <div className="mobileHeading">Tracking N.</div>
                                            <div>{getDeliveryItemTitle(obj)}</div>
                                        </>
                                    ) : null}
                                </DeliveryItemsColStyled>
                                <DeliveryItemsColStyled className="listCta">
                                    <div className="mobileHeading">&nbsp;</div>
                                    {obj.customsPaymentRequired ? (
                                        <div className="customChargesLink">
                                            <button className="cta-link gtm-linkclick" type="button" aria-label="Click for pay custom charges">
                                                Pay Custom charges
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="showDetails">
                                            <button className="cta-link gtm-linkclick" type="button" aria-label="Click for details">
                                                Details
                                            </button>
                                        </div>
                                    )}
                                </DeliveryItemsColStyled>
                            </DeliveryItemsLinkStyled>
                        );
                    })}
                </DeliveryItemsGridWrapperStyled>
            ) : (
                <NoItemsCTA noItemsMsg={noItemsMsg} activeTab={activeTab} />
            )}
        </DeliveryItemsGridStyled>
    );
};

DeliveryItemsGrid.propTypes = {
    data: PropTypes.object,
    noItemsMsg: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
    ariaLabelledby: PropTypes.string,
	activeTab: PropTypes.string
};

export default DeliveryItemsGrid;
